import { TanStackDevtools } from '@tanstack/react-devtools';
import { formDevtoolsPlugin } from '@tanstack/react-form-devtools';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import axios from 'axios';
import { registerMaintenanceModeInterceptor, startBrowserSession } from '@urbanx/agx.auth.client';

registerMaintenanceModeInterceptor(axios, import.meta.env.BASE_URL);

startBrowserSession();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <>
    <App />
    {import.meta.env.DEV && <TanStackDevtools plugins={[formDevtoolsPlugin()]} />}
  </>
);
